var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center d-flex justify-center"},[_c('v-col',{staticClass:"justify-center",attrs:{"cols":"4"}},[_c('h1',{staticClass:"white--text"},[_vm._v("Recherchez votre Cocktail par ingrédients")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }